import {createContext} from 'react';

/** Ids of steps no trigger reaches (`unreachableNodeIds`). Empty outside the editor, e.g. the template preview. */
export const UnreachableNodesContext = createContext<ReadonlySet<string>>(new Set());
